
import chMessages from '../locales/zh-ZH';

const ChLang = {
    messages: {
        ...chMessages
    },
    locale: 'zh-ZH',
  
};
export default ChLang;